import axios from 'axios';

export class ViesHttpClient {
    /**
     * @param {String} nip
     * @return {Promise<BaseModel>}
     */
    async check(nip) {
        const url = `/app/vies.php`
        const response = await axios.post(url, {
            nip
        })
        .catch((error) => {
            return false;
        });

        return response.data.valid;
    }
}
